import { MobiDocument } from './MobiDocument';
import { Activite } from './Activite';
import { Individu } from './Individu';
import { HistoGroupeDocument } from './HistoGroupeDocument';
import { utils } from '@/util';
import { PointageInoeDocument } from './PointageInoeDocument';

export class Inscription extends MobiDocument {
    private _id: string;
    private _rev: string;
    private id: number;
    private activite_id: number;
    private individu_id: number;
    private datedebut: string;
    private datefin: string;
    private noninscrit: boolean;


    public constructor(inscription: any) {
        super();
        this._id = inscription._id;
        this._rev = inscription._rev;
        this.id = inscription.id;
        this.activite_id = inscription.activite_id;
        this.individu_id = inscription.individu_id;
        this.datedebut = inscription.datedebut;
        this.datefin = inscription.datefin;
        this.noninscrit = inscription.noninscrit;

    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getActivite_id(): number {
        return this.activite_id;
    }

    public setActivite_id(activite_id: number): void {
        this.activite_id = activite_id;
    }

    public getIndividu_id(): number {
        return this.individu_id;
    }

    public setIndividu_id(individu_id: number): void {
        this.individu_id = individu_id;
    }

    public getDateDebut(): string {
        return this.datedebut;
    }

    public setDateDebut(dateDebut: string): void {
        this.datedebut = dateDebut;
    }

    public getDateFin(): string {
        return this.datefin;
    }

    public setDateFin(dateFin: string): void {
        this.datefin = dateFin;
    }

    public getActivite(): Activite {
        return this.memdb.findOne({
            doctype: "ActiviteDocument",
            fkey: "id",
            fvalue: this.activite_id

        })
    }

    public getIndividu(): Individu {
        let individu = this.memdb.findOne({
            doctype: "IndividuDocument",
            fkey: "id",
            fvalue: this.individu_id
        }, false) as Individu;
        if (individu != null) {
            individu.setInscription_id(this.id);
        }
        return individu
    }

    public isNoninscrit(): boolean {
        return this.noninscrit;
    }

    public setNoninscrit(noninscrit: boolean): void {
        this.noninscrit = noninscrit;
    }

    public getHistoGroupe(date?: string): HistoGroupeDocument{
        let histoGroupe : HistoGroupeDocument
        let histoGroupes : Array<HistoGroupeDocument>
        let datestr 
        if(!date)
            datestr = utils.getCurrentTimeNow().format("YYYY-MM-DD")
        else
            datestr = date
        histoGroupes = this.memdb.find({
            doctype: "HistoGroupeDocument",
            fkey: "inscriptionan_id",
            fvalue: this.id
        }) as Array<HistoGroupeDocument>;
        
        histoGroupe = histoGroupes[0];

        for(var i=1; i<histoGroupes.length; i++){
            if(utils.getDateFromString(histoGroupes[i].getDateeffet(), "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD") >= 
            utils.getDateFromString(histoGroupe.getDateeffet(), "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD")
            && utils.getDateFromString(histoGroupes[i].getDateeffet(), "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD") <=
            utils.getDateFromString(datestr, "YYYY-MM-DD").format("YYYY-MM-DD")){
                histoGroupe = histoGroupes[i]
            }
        } 
        return histoGroupe
    }

    public getPointagesPrev(): Array<PointageInoeDocument>{
        let pointages : Array<PointageInoeDocument> = []
        this.memdb.find({
            doctype: "PointageDocument",
            fkey: "schedulable_id",
            fvalue: this.id
        }).forEach((pointage: PointageInoeDocument) => {
            if(pointage.getDate()===utils.getCurrentTimeNow().format('YYYY-MM-DD') && pointage.getType()==='PREVISIONNEL'){
                pointages.push(pointage)
            }
        });
        return pointages;
    }
}